import axios from 'axios';
import baseURL from './configRoutes2.js';
import { toast } from 'react-toastify';
import { assertPayloadWithinLimits, assertQueryWithinLimit } from '../utils/requestLimits';
import { sanitizePayload, sanitizeQueryString } from '../utils/inputSanitizer';

import { userLoggedOut } from "../redux/auth/authSlice.js";
const LOGIN_GUARD_MS = 30 * 1000;
const LOGIN_ENDPOINTS = new Set([
  "admin-login",
  "school-login",
  "faculty-login",
  "faculty-login-password",
  "get-otp",
  "get-faculty-otp",
]);

const handleLogout = async (dispatch) => {
   try {
     await fetch(
       `https://ecoclubs.education.gov.in/api/logout`,
       {
         method: "GET",
         headers: {
           "Content-Type": "application/json",
         },
         credentials: "include",
       }
     );
   } catch (error) {
     toast.error("Logout Failed");
     console.log(error);
   }
   dispatch(userLoggedOut());
 };

 export default async function axiosConn(method, url, data, header, dispatch) {
   try {
    const finalHeader = header || {};
    const sanitizedUrl = sanitizeQueryString(baseURL.baseURL + url);
    const sanitizedData = sanitizePayload(data);
    assertQueryWithinLimit(sanitizedUrl);
    assertPayloadWithinLimits(sanitizedData);
      const response = await axios({
      url: sanitizedUrl,
         method: method,
      data: sanitizedData,
      headers: finalHeader,
         timeout: LOGIN_ENDPOINTS.has(url) ? LOGIN_GUARD_MS : 0,
         withCredentials: true,  // Uncomment if needed
      });
      console.log('Response2:', response);

      return response;
   } catch (error) {
      if (LOGIN_ENDPOINTS.has(url) && (error.code === "ECONNABORTED" || String(error.message || "").toLowerCase().includes("timeout"))) {
      toast.error("Login request timed out. Please try again.");
      }
      // Handle the case where the error status is 401
      if (error.response?.status === 401 || (error.response?.status === 400 && ["Please login to access this resource!", "Please login for access this resources!"].includes(error.response?.data?.message))) {
        const message = error.response?.data?.message || "Session expired. Please login again.";
         toast.error(message);
         

         // Call the handleLogout function to log the user out
         if (dispatch) {
            handleLogout(dispatch);
         }
      }

      console.error('Error during request:', error);
      throw error;  // Re-throw error if needed
   }
}
